import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import { formatNumber, formatPercentage } from 'src/utils/format';
import { contentTypeFromBriefType } from 'src/data/brief';
import { getContentTypeTaxonomyName } from 'src/data/contentType';
import Score, { SCORE_SIZE, getScoreProps } from 'src/components/Score';
import { ButtonText } from 'src/components/ButtonText';
import { Loader } from './components/Loader';
import { useStyles } from './useStyles';

export const ScoringMethod = ({
  briefType,
  score,
  basedOnValue,
  loading,
  blocked,
  locked,
  readOnly,
  displayScoringMethod,
  scoringMethodName,
  onScoringMethodClick,
}) => {
  const styles = useStyles();

  const contentType = contentTypeFromBriefType(briefType);
  const contentTypeTaxonomyName = getContentTypeTaxonomyName(contentType);
  const displayedName = scoringMethodName || `Undefined ${contentTypeTaxonomyName}`;
  const similarCopiesFormatted = formatNumber(blocked ? 0 : basedOnValue || 0);

  const { textScore } = getScoreProps(score);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className={styles.root}>
      <Typography className={styles.subtitle}>How will this text perform?</Typography>
      <div className={styles.container}>
        <Score
          classes={{ score: styles.score }}
          score={score}
          size={SCORE_SIZE.xxxl}
          locked={locked}
          strokeWidth={4}
        />

        <Typography className={styles.title}>
          {`Better than ${formatPercentage(
            textScore
          )} of ${similarCopiesFormatted} similar texts in Anyword's`}{' '}
          <ButtonText
            className={styles.changeModelButton}
            onClick={!readOnly && !locked ? onScoringMethodClick : undefined}
          >
            {displayedName}
          </ButtonText>{' '}
          data set
        </Typography>
      </div>
    </div>
  );
};

ScoringMethod.propTypes = {
  briefType: PropTypes.string,
  score: PropTypes.number,
  basedOnValue: PropTypes.number,
  loading: PropTypes.bool,
  blocked: PropTypes.bool,
  locked: PropTypes.bool,
  readOnly: PropTypes.bool,
  displayScoringMethod: PropTypes.bool,
  scoringMethodName: PropTypes.string,
  onScoringMethodClick: PropTypes.func,
};

ScoringMethod.defaultValues = {
  briefType: null,
  score: null,
  basedOnValue: null,
  loading: null,
  blocked: null,
  locked: null,
  readOnly: null,
  displayScoringMethod: null,
  scoringMethodName: null,
  onScoringMethodClick: null,
};
